import { useRef } from "react";

import { styled } from "styled-components";

import { Sortable } from "components/lib/dnd/Sortable";

import { ILaneData } from ".";

export const LaneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 300px;
  width: 300px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgb(212, 213, 215) transparent;

  margin: 0 10px;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  max-height: 100%;
  padding: 4px 0 4px 4px;

  .lane-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 8px;

    overflow: auto;
    padding: 4px;
  }

  border-radius: 5px;
  background: rgb(241, 242, 244);
  box-shadow:
    rgba(9, 30, 66, 0.25) 0px 1px 1px 0px,
    rgba(9, 30, 66, 0.31) 0px 0px 1px 0px;
`;

const CardWrapper = styled.div`
  cursor: pointer;
  z-index: 1;
`;

type ProjectLaneProps = {
  lane: ILaneData;
  index: number;
  renderLaneHeader?: (
    lane: ILaneData,
    dragRef: React.RefObject<HTMLDivElement>,
  ) => React.ReactNode;
  renderCard: (card: ILaneData["cards"][0]) => React.ReactNode;
};

export const ProjectLane = ({
  lane,
  index,
  renderLaneHeader,
  renderCard,
}: ProjectLaneProps) => {
  const dragRef = useRef<HTMLDivElement>(null);

  return (
    <Sortable
      key={lane.id}
      id={lane.id}
      index={index}
      type="lane"
      accept={["card", "lane"]}
      disabled={lane.draggingDisabled}
      style={{ height: "100%" }}
      handleRef={dragRef}
      collisionPriority="Low"
    >
      <LaneWrapper>
        {renderLaneHeader ? renderLaneHeader(lane, dragRef) : null}

        <div className="lane-content">
          {lane.cards.length === 0 ?
            <div style={{ height: 100 }} />
          : null}
          {lane.cards.map((card, cardIndex) => (
            <Sortable
              key={card.id}
              id={card.id}
              index={cardIndex}
              accept={["card"]}
              type="card"
              disabled={card.draggingDisabled}
            >
              <CardWrapper>{renderCard(card)}</CardWrapper>
            </Sortable>
          ))}
        </div>
      </LaneWrapper>
    </Sortable>
  );
};
